import routes from "../../routes";
import { GA_EVENTS } from "../ga";
import { applicationOverviewRoutes, detailedFinanceRoutes } from "../../constants";

export const gaEventsMap = {
  ...detailedFinanceRoutes.reduce(
    (acc, route) => ({ ...acc, [route]: GA_EVENTS.PRODUCT_PAGE }),
    {}
  ),
  ...applicationOverviewRoutes.reduce(
    (acc, route) => ({ ...acc, [route]: GA_EVENTS.PRODUCT_APPLY }),
    {}
  ),
  [routes.applicantInfo]: GA_EVENTS.PRODUCT_START,
  [routes.comeBackLogin]: GA_EVENTS.COMEBACK_START,
  [routes.stakeholdersInfo]: GA_EVENTS.COMPANY_INFORMATION_SUBMITTED,
  [routes.finalQuestions]: GA_EVENTS.COMPANY_STAKEHOLDER_SUBMITTED,
  [routes.selectServices]: GA_EVENTS.POST_ELIGIBILITY_COMPANY_STAKEHOLDER_SUBMITTED,
  [routes.stakeholdersInfoPE]: GA_EVENTS.POST_ELIGIBILITY_COMPANY_INFORMATION_SUBMITTED,
  [routes.SubmitApplication]: GA_EVENTS.POST_ELIGIBILITY_UPLOAD_DOCUMENTS_SUBMITTED,
  [routes.comeBackLoginVerification]: GA_EVENTS.COMEBACK_OTP_SUBMITTED,
  [routes.borrowAmount]: GA_EVENTS.PRODUCT_OTP_SUBMITTED,
  [routes.companyInfo]: GA_EVENTS.BORROW_AMOUNT_SUBMITTED,
  [routes.verifyOtp]: GA_EVENTS.PRODUCT_BASIC_INFORMATION,
  [routes.ApplicationSubmitted]: GA_EVENTS.FORM_SUBMITTED,
  [routes.uploadDocuments]: GA_EVENTS.FINAL_QUESTION_SUBMITTED,
  [routes.AECBcheck]: GA_EVENTS.UPLOAD_DOCUMENTS_SUBMITTED,
  [routes.companyInfoPE]: GA_EVENTS.ELIGIBILITY_SUBMITTED,
  [routes.uploadDocumentsPE]: GA_EVENTS.SELECT_SERVICE_SUBMITTED,
  [routes.consentVerify]: GA_EVENTS.AECB_CONSENT_OTP_START,
  [routes.aecbFtsAuthorize]: GA_EVENTS.AECB_CONSENT_OTP_SUBMITTED,
  [routes.consentAuthorized]: GA_EVENTS.AECB_CONSENT_AUTHORIZED,
  [routes.uploadAdditionalDocumentsVerify]: GA_EVENTS.ADDITIONAL_DOCUMENTS_UPLOAD_OTP_START,
  [routes.additionalDocuments]: GA_EVENTS.ADDITIONAL_DOCUMENTS_UPLOAD_OTP_SUBMITTED,
  [routes.additionalDocumentsSubmitted]: GA_EVENTS.ADDITIONAL_DOCUMENTS_UPLOAD_SUBMITTED,
  [routes.userVerify]: GA_EVENTS.DROPOFF_AUTHORIZE_OTP_START,
  [routes.userAuthorize]: GA_EVENTS.DROPOFF_AUTHORIZE_OTP_SUBMITTED,
  [routes.userAuthorized]: GA_EVENTS.DROPOFF_AUTHORIZE_REQUEST_SUBMITTED
};
